<app-card-layout-content class="inactive-account-page">
  <app-card-layout-content-header [noLogo]="true">
    <app-card-layout-content-image>
      <app-feedback-failure-svg-icon></app-feedback-failure-svg-icon>
    </app-card-layout-content-image>
    <app-card-layout-content-title>
      <h1 i18n>Account inattivo</h1>
    </app-card-layout-content-title>
    <app-card-layout-content-description>
      <div class="p-d-flex p-flex-column p-text-center p-mb-5">
        <span i18n
          >Per riattivare il tuo account devi resettare la password tramite il link che hai ricevuto al tuo indirizzo
          email.
        </span>
        <!-- fixme: replace XX time with correct value-->
        <span class="p-mt-4" i18n>Ricordati di effettuare il reset entro XX tempo.</span>
      </div>
    </app-card-layout-content-description>
  </app-card-layout-content-header>
  <div class="p-mt-auto">
    <div class="p-d-flex p-flex-column p-ai-center p-mb-3">
      <span i18n>Hai bisogno di aiuto?</span>
      <a class="p-mt-1 p-text-bold" [href]="'tel:' + helplineNumber" i18n>Contatta l’assistenza</a>
    </div>
    <button
      class="inactive-account-page__login-button"
      pButton
      label="Torna al login"
      i18n-label="IactiveAccount|Label button torna al login"
      (click)="onBackToLoginPageButton()"
    ></button>
  </div>
</app-card-layout-content>
